
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            timeout: {
                type: Number,
                default: -1,
            },
            text: {
                type: String,
                default: "",
            },
            color: {
                type: String,
                default: "",
            },
            shown: {
                type: Boolean,
                default: false,
            },
            queueLength: {
                type: Number,
                default: null,
            }
        },
    });
    